export const ru = {
    all: 'Все',
    'find-platforms': 'Найти площадки',
    format: 'Формат',
    'on-a-map': 'На карте',
    operator: 'Оператор',
    selected: 'Выбранные'
};
